import React from 'react';
import MenuBar from '../components/Menubar';
import CategoryFeed from '../components/CategoryFeed';

type Props = {
  location: any;
  user: any;
  handleLogin(user): void;
};

type Category = { id: number; label: string; slug: string };

const CATEGORIES: Category[] = [
  // Row 1
  { id: 1, label: 'Entree', slug: 'entree' },
  { id: 3, label: 'Pizza', slug: 'pizza' },
  { id: 2, label: 'Burgers', slug: 'burgers' },

  // Row 2
  { id: 13, label: 'Handheld', slug: 'handheld' },
  { id: 6, label: 'Dessert', slug: 'dessert' },
  { id: 7, label: 'Breakfast', slug: 'breakfast' },

  // Row 3
  { id: 4, label: 'Apps', slug: 'apps' },
  { id: 5, label: 'Sides', slug: 'sides' },
  { id: 14, label: 'Fast Food', slug: 'fast food' },
];

const CategoryPage: React.FC<Props> = (props) => {
  const [active, setActive] = React.useState<Category | null>(null);

  return (
    <main className='main-bg eat-bg'>
      <div className="container">
        <MenuBar user={props.user} />

        <h2 className='text-center pt-3 pb-2 uppercase' style={{ fontSize: '40px', marginTop: '-10px', marginBottom: '-15px' }}>
          Categories
        </h2>

        <div className="category-page-grid">
          {CATEGORIES.map((c) => (
            <button
              key={c.id}
              type="button"
              className={`category-page-pill ${active?.id === c.id ? 'is-active' : ''}`}
              onClick={() => setActive(c)}
              aria-pressed={active?.id === c.id}
            >
              {c.label}
            </button>
          ))}
        </div>
      </div>
      <section style={{ marginTop: '1px', marginBottom: '20px' }}>
        {active && (
          <CategoryFeed
            categoryId={active.id}
            categoryName={active.label}
            user={props.user}
            location={props.location}
            handleLogin={props.handleLogin}
          />
        )}
      </section>
    </main>
  );
};

export default CategoryPage;
